import { format } from "date-fns"
import { get, ref, set, child } from "firebase/database"

import { getDisplayName } from "../utils/helpers"

export const createUser = async (database, user, fullName) => {
  const [firstName, lastName = ""] = getDisplayName(user).split(" ") || []
  const givenName = fullName?.firstName || firstName
  const familyName = fullName?.lastName || lastName
  const email = user.email || user.providerData?.[0]?.email

  if (!email) {
    throw new Error("No email provided")
  }

  const snapshot = await get(child(ref(database), `users/${user.uid}`))

  if (snapshot.exists()) {
    return
  }

  await set(ref(database, "users/" + user.uid), {
    email,
    givenName,
    familyName,
    uid: user.uid,
    customerType: "payg",
    photoUrl: user.photoURL,
    name: `${givenName} ${familyName}`,
    timestamps: { createdAt: user.metadata.createdAt },
    joinDate: format(new Date(+user.metadata.createdAt), "yyyy/MM/dd"),
  })
}
